/* eslint-disable react/prop-types */
import React from 'react'

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  Grid,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '16px',
      padding: '8px',
      minWidth: '400px',
      maxWidth: '500px',
      fontFamily: 'Red Hat Display Regular',
    },
  },
  dialogTitle: {
    textAlign: 'center',
    padding: '24px 24px 16px',
    fontFamily: 'Red Hat Display Regular',
  },
  iconContainer: {
    fontSize: '3.5rem',
    lineHeight: 1,
    marginBottom: '16px',
  },
  title: {
    fontFamily: 'Red Hat Display Regular',
    fontWeight: 'normal',
    fontSize: '1.25rem',
    marginTop: '8px',
  },
  dialogContent: {
    padding: '16px 32px',
    textAlign: 'center',
    fontFamily: 'Red Hat Display Regular',
  },
  message: {
    fontFamily: 'Red Hat Display Regular',
    fontWeight: 'normal',
    fontSize: '1rem',
    lineHeight: '1.6',
    color: '#666',
  },
  dialogActions: {
    padding: '16px 24px 24px',
    justifyContent: 'space-between',
    fontFamily: 'Red Hat Display Regular',
  },
  btnCancel: {
    minWidth: '120px',
    padding: '10px 24px',
    borderRadius: '50px',
    border: '1px solid #6064ff',
    color: '#6064ff',
    fontFamily: 'Red Hat Display Regular',
    fontWeight: '500',
    backgroundColor: '#ffffff',
    textTransform: 'none',
    '&:hover': {
      color: '#FF40FC',
      border: '1px solid #FF40FC',
      backgroundColor: '#ffffff',
    },
  },
  btnConfirm: {
    minWidth: '120px',
    padding: '10px 24px',
    borderRadius: '50px',
    border: 'none',
    backgroundColor: '#5e44ff',
    color: 'white',
    fontFamily: 'Red Hat Display Regular',
    fontWeight: '500',
    textTransform: 'none',
    '&:hover': {
      fontWeight: 'bolder',
      backgroundColor: '#ef0bef',
      boxShadow: '-7px 7px 0px #000000',
      border: '2px solid #000000',
      borderRadius: '50px',
      opacity: '1',
    },
  },
}))

function RefundConfirmationDialog({ open, onClose, onConfirm }) {
  const classes = useStyles()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.dialog}
      aria-labelledby="refund-dialog-title"
      aria-describedby="refund-dialog-description"
    >
      <DialogTitle id="refund-dialog-title" className={classes.dialogTitle}>
        <Grid container direction="column" alignItems="center">
          <Grid item>
            <div className={classes.iconContainer}>
              <span style={{ fontSize: '3.5rem', lineHeight: 1 }}>⚠️</span>
            </div>
          </Grid>
          <Grid item>
            <Typography variant="h6" className={classes.title}>
              Confirmación de anulación de pago
            </Typography>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography className={classes.message} id="refund-dialog-description">
          Esta acción es irreversible. No se expedirá la póliza de SOAT y el crédito o pago entrará
          en proceso de devolución. ¿Está seguro que desea continuar?
        </Typography>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button onClick={onClose} variant="contained" className={classes.btnCancel}>
          Cancelar
        </Button>
        <Button onClick={onConfirm} variant="contained" className={classes.btnConfirm}>
          Confirmar anulación
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RefundConfirmationDialog
